/**
 * <gh-recommendations> — loads Shopify product recommendations into a section (Gaucho House,
 * sections/gh-other-designs.liquid).
 *
 * The page renders the section hidden, with the fallback products (a collection without the
 * current product) inside <template data-gh-recommendations-fallback>. This element requests
 * the same section from the recommendations endpoint (`data-url`, intent "related") and shows
 * what comes back; when Shopify has no recommendations it shows the fallback instead, and when
 * neither has products the section stays hidden.
 */
class GhRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded) return;
    this.dataset.loaded = 'true';

    // Already rendered with recommendations (e.g. the theme editor re-rendering the endpoint HTML)
    if (this.querySelector(':scope > gh-carousel')) {
      this.hidden = false;
      return;
    }

    this.load();
  }

  async load() {
    let content = null;

    try {
      const response = await fetch(this.dataset.url);
      if (response.ok) {
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const carousel = html.querySelector('gh-recommendations > gh-carousel');
        if (carousel?.querySelector('[data-gh-carousel-slide]')) content = carousel;
      }
    } catch {
      // Network or endpoint error: fall back below
    }

    if (!content) {
      const fallback = this.querySelector('template[data-gh-recommendations-fallback]');
      const carousel = fallback?.content.querySelector('gh-carousel');
      if (carousel?.querySelector('[data-gh-carousel-slide]')) content = carousel.cloneNode(true);
    }

    if (!content) return;

    this.replaceChildren(document.importNode(content, true));
    this.hidden = false;
  }
}

if (!customElements.get('gh-recommendations')) customElements.define('gh-recommendations', GhRecommendations);
